import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import DashboardTable from 'features/dashboard/table/DashboardTable'
import { fetchCreativeTable } from 'features/dashboard/table/creative/creativeTableSlice'
import CreativeTableHeader from 'features/dashboard/table/creative/CreativeTableHeader'
import { DashboardTypes } from 'features/Codes'
import useDebounce from 'utils/hooks/useDebounce'
import useDefaultSort from 'features/dashboard/table/column/useDefaultSort'

const CreativeTable = () => {
  const dispatch = useDispatch()
  const {
    common: { from, to },
    filter: { filters },
    table: {
      config: {
        columns: { [DashboardTypes.CREATIVE]: columns },
      },
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
      creativeTable: { page, sort },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const debouncedColumns = useDebounce(columns, 500)
  useDefaultSort(debouncedColumns)

  useEffect(() => {
    const { abort } = dispatch(fetchCreativeTable())
    return () => abort()
  }, [
    dispatch,
    from,
    to,
    page,
    sort,
    campaignIds,
    adGroupIds,
    filters,
    debouncedColumns,
  ])

  return (
    <div className="set_table">
      <h4 className="screen_out">소재 탭 내용</h4>
      <CreativeTableHeader />
      <DashboardTable />
    </div>
  )
}
export default CreativeTable
